var _path, _path2, _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerfilMulher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 164,
    viewBox: "0 0 162 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 160.5C124.907 160.5 160.5 124.907 160.5 81C160.5 37.0934 124.907 1.5 81 1.5C37.0934 1.5 1.5 37.0934 1.5 81C1.5 124.907 37.0934 160.5 81 160.5Z",
    fill: "#CCEFFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 3C124.078 3 159 37.922 159 81C159 124.078 124.078 159 81 159C37.922 159 3 124.078 3 81C3 37.922 37.922 3 81 3ZM81 0C36.336 0 0 36.336 0 81C0 125.664 36.336 162 81 162C125.664 162 162 125.664 162 81C162 36.336 125.664 0 81 0Z",
    fill: "#1B3858"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 156,
    height: 156
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 159C124.078 159 159 124.078 159 81C159 37.9218 124.078 3 81 3C37.9218 3 3 37.9218 3 81C3 124.078 37.9218 159 81 159Z",
    fill: "#CCEFFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 18.947C93.15 18.947 103 28.797 103 40.947V82.609H59V40.947C59 28.796 68.85 18.947 81 18.947Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.122 162H17.878V99.5C17.878 88.515 26.783 79.61 37.768 79.61H124.232C135.217 79.61 144.122 88.515 144.122 99.5V162Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.122 163.5H17.878C17.05 163.5 16.378 162.828 16.378 162V99.5C16.378 87.706 25.974 78.11 37.768 78.11H124.233C136.027 78.11 145.623 87.706 145.623 99.5V162C145.622 162.828 144.95 163.5 144.122 163.5ZM19.378 160.5H142.622V99.5C142.622 89.36 134.372 81.11 124.232 81.11H37.768C27.628 81.11 19.378 89.36 19.378 99.5V160.5Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.246 61.618H69.755V79.61H92.246V61.618Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.258 50.319C60.049 50.319 58.258 48.528 58.258 46.319C58.258 44.11 60.049 42.319 62.258 42.319",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.258 51.819C59.226 51.819 56.758 49.351 56.758 46.319C56.758 43.287 59.226 40.819 62.258 40.819V43.819C60.879 43.819 59.758 44.94 59.758 46.319C59.758 47.698 60.879 48.819 62.258 48.819V51.819Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.743 42.319C101.952 42.319 103.743 44.11 103.743 46.319C103.743 48.528 101.952 50.319 99.743 50.319",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.743 51.819V48.819C101.122 48.819 102.243 47.698 102.243 46.319C102.243 44.94 101.122 43.819 99.743 43.819V40.819C102.775 40.819 105.243 43.287 105.243 46.319C105.243 49.351 102.775 51.819 99.743 51.819Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 73.322C70.649 73.322 62.258 64.931 62.258 54.58V39.572H99.742V54.579C99.742 64.93 91.351 73.322 81 73.322Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.154 122.689H17.878V162H35.154V122.689Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.653 163.5H16.378V121.189H36.653V163.5ZM19.378 160.5H33.653V124.189H19.378V160.5Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.154 110.694H17.878V122.689H35.154V110.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.153 124.189H17.878C17.05 124.189 16.378 123.517 16.378 122.689V110.694C16.378 109.866 17.05 109.194 17.878 109.194H35.153C35.981 109.194 36.653 109.866 36.653 110.694V122.689C36.653 123.518 35.981 124.189 35.153 124.189ZM19.378 121.189H33.653V112.194H19.378V121.189Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.123 122.689H126.847V162H144.123V122.689Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.622 163.5H125.347V121.189H145.622V163.5ZM128.347 160.5H142.622V124.189H128.347V160.5Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.123 110.694H126.847V122.689H144.123V110.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.122 124.189H126.847C126.019 124.189 125.347 123.517 125.347 122.689V110.694C125.347 109.866 126.019 109.194 126.847 109.194H144.122C144.95 109.194 145.622 109.866 145.622 110.694V122.689C145.622 123.518 144.95 124.189 144.122 124.189ZM128.347 121.189H142.622V112.194H128.347V121.189Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 79.61C100 90.103 91.493 98.61 81 98.61C70.507 98.61 62 90.103 62 79.61H100Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 100.11C69.696 100.11 60.5 90.914 60.5 79.61V78.11H101.5V79.61C101.5 90.914 92.304 100.11 81 100.11ZM63.563 81.11C64.327 90.06 71.855 97.11 81 97.11C90.145 97.11 97.673 90.06 98.437 81.11H63.563Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.247 56.6791C89.247 61.2331 85.555 64.9261 81 64.9261C76.446 64.9261 72.753 61.2341 72.753 56.6791H89.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.654 49.594C71.7586 49.594 72.654 48.6986 72.654 47.594C72.654 46.4894 71.7586 45.594 70.654 45.594C69.5494 45.594 68.654 46.4894 68.654 47.594C68.654 48.6986 69.5494 49.594 70.654 49.594Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.347 49.594C92.4516 49.594 93.347 48.6986 93.347 47.594C93.347 46.4894 92.4516 45.594 91.347 45.594C90.2424 45.594 89.347 46.4894 89.347 47.594C89.347 48.6986 90.2424 49.594 91.347 49.594Z",
    fill: "#1B3858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 81,
    y1: 162,
    x2: 81,
    y2: 79.6103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1478,
    stopColor: "#097BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3887,
    stopColor: "#2191F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6929,
    stopColor: "#49B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78DFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilMulher);
export default __webpack_public_path__ + "static/media/perfil-mulher.75fd3f09a913aa1335ab4a000eba3d5b.svg";
export { ForwardRef as ReactComponent };